<template>
  <v-table class="table_variant_surcharge">
    <thead>
      <tr>
        <th
          class="text-left"
          colspan="3">
          {{
            $t(
              "components.Calculations.Variants.ViewParts.SurchargeCashSalePriceTab.ProductSpecificSurcharges"
            )
          }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td class="wide_col">
          <CalcInputNumber
            :id="nodeId"
            field="interest_period_finished_stock_part"
            :rules="[positive]" />
        </td>
        <td class="input_col">
          <CalcOutput
            :id="nodeId"
            field="interest_costs_on_finished_stock_part"
            hide-label />
        </td>
        <td class="e_per_piece_col">
          {{ $t("units.e_per_piece") }}
        </td>
      </tr>

      <tr>
        <td class="wide_col">
          <CalcInputNumber
            :id="nodeId"
            field="product_specific_development_costs_part"
            :rules="[positive]" />
        </td>
        <td class="input_col">
          <CalcOutput
            :id="nodeId"
            field="allocation_of_product_specific_development_costs_part"
            hide-label />
        </td>
        <td class="e_per_piece_col">
          {{ $t("units.e_per_piece") }}
        </td>
      </tr>

      <tr>
        <td class="wide_col">
          <CalcInputNumber
            :id="nodeId"
            field="product_specific_rampup_costs_part"
            :rules="[positive]" />
        </td>
        <td class="input_col">
          <CalcOutput
            :id="nodeId"
            field="allocation_of_product_specific_rampup_costs_part"
            hide-label />
        </td>
        <td class="e_per_piece_col">
          {{ $t("units.e_per_piece") }}
        </td>
      </tr>

      <tr>
        <td class="wide_col">
          <CalcInputNumber
            :id="nodeId"
            field="product_specific_packaging_and_cargo_carrier_costs_part"
            :rules="[positive]" />
        </td>
        <td class="input_col">
          <CalcOutput
            :id="nodeId"
            field="allocation_of_product_specific_packaging_cargocarier_costs_part"
            hide-label />
        </td>
        <td class="e_per_piece_col">
          {{ $t("units.e_per_piece") }}
        </td>
      </tr>

      <tr>
        <td class="wide_col">
          {{
            $t(
              "components.Calculations.Variants.ViewParts.SurchargeCashSalePriceTab.ProductSpecificSurcharges"
            )
          }}
        </td>
        <td class="input_col">
          <CalcOutput
            :id="nodeId"
            field="product_specific_surcharges_after_production_costs_part"
            hide-label />
        </td>
        <td class="e_per_piece_col">
          {{ $t("units.e_per_piece") }}
        </td>
      </tr>
    </tbody>
  </v-table>
</template>

<script setup>
import CalcOutput from "../../../../../components/Elements/CalcOutput.vue";
import CalcInputNumber from "@/components/Elements/CalcInputNumber.vue";

import { useTranslation } from "i18next-vue";

import { useCommonRules } from "@/validations/common";
const { t } = useTranslation();
const { positive } = useCommonRules(t);

defineProps({
  variant: {
    type: Object,
    required: true
  },
  nodeId: {
    type: String,
    required: true
  }
});
</script>
